export default (api) => ({
  fetch: (params) => api.$get("/certs", { params }),
  fetchList: (params) => api.$get("/certs", { params: { ...params, size: 10000 } }),
  create: (body) => api.$post("/certs", body),
  remove: (id) => api.$delete(`/certs/${id}`),
});
